module.exports = __webpack_public_path__ + "static/media/Photo18.e93cac88.jpg";